import React from 'react'
import PropTypes from 'prop-types'
import AutomaticQuestions from 'components/ProspectDashboard/AutomaticQuestions'
import { Expansible } from 'components/Expansible'
import ReferenceCheck from 'components/ExpandedInfo/ReferenceCheck'

import styles from './styles'

function BuildFinancialPendingsInfo(props) {
  const { reviewData } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Dados auxiliares para a análise</h2>
      {reviewData?.extra_questions && (
        <Expansible title="Respostas às questões automáticas relacionadas à pergunta">
          <AutomaticQuestions questions={reviewData?.extra_questions} />
        </Expansible>
      )}

      <Expansible title="Dados do Bureau relacionados ao assessor">
        <ReferenceCheck financial_pendings_data={reviewData.financial_pendings_data} credit_score_data={reviewData.credit_score_data} />
      </Expansible>
    </div>
  )
}

BuildFinancialPendingsInfo.propTypes = {
  reviewData: PropTypes.shape({
    created: PropTypes.string,
    updated: PropTypes.string,
    uuid: PropTypes.string,
    decisions: PropTypes.arrayOf(
      PropTypes.shape({
        created: PropTypes.string,
        updated: PropTypes.string,
        uuid: PropTypes.string,
        area_decision: PropTypes.string,
        reviewer_id: PropTypes.number,
        reviewer: PropTypes.shape({
          uuid: PropTypes.string,
          email: PropTypes.string,
          display_name: PropTypes.string,
        }),
        reviewer_comment: PropTypes.string,
        current_review_area: PropTypes.string,
      }),
    ),
    result: PropTypes.string,
    current_review_area: PropTypes.string,
    reason: PropTypes.string,
    related_form_answers: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        answer_object: PropTypes.object,
      }),
    ),

    extra_questions: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        text: PropTypes.string,
        occurrence: PropTypes.shape({
          reason: PropTypes.string,
          classification: PropTypes.string,
        }),
        answered: PropTypes.bool,
        subject: PropTypes.string,
      }),
    ),
    type: PropTypes.string,
    financial_pendings_data: PropTypes.shape({
      credit_score_data: PropTypes.shape({
        uuid: PropTypes.string,
        warnings: PropTypes.array,
        created: PropTypes.string,
        updated: PropTypes.string,
        quod_score: PropTypes.number,
      }),
      financial_pendings_data: PropTypes.shape({
        uuid: PropTypes.string,
        warnings: PropTypes.array,
        created: PropTypes.string,
        updated: PropTypes.string,
        has_pendings: PropTypes.bool,
        reason: PropTypes.string,
        total_value: PropTypes.number,
        details: PropTypes.shape({
          uuid: PropTypes.string,
          warnings: PropTypes.array,
          created: PropTypes.string,
          updated: PropTypes.string,
          service_id: PropTypes.string,
          service_type: PropTypes.string,
          status: PropTypes.string,
          data: PropTypes.shape({
            credcadastral: PropTypes.shape({
              synthetic_protest: PropTypes.shape({
                total_value: PropTypes.number,
                last_protest: PropTypes.string,
                quantity_ocurrence: PropTypes.number,
                ocurrences: PropTypes.array,
              }),
              financial_pending: PropTypes.shape({
                quantity_ocurrence: PropTypes.number,
                total_value: PropTypes.number,
                date_first: PropTypes.string,
                total_creditors: PropTypes.string,
                higher_value: PropTypes.number,
                first_value: PropTypes.number,
                biggest_date: PropTypes.string,
                ocurrences: PropTypes.arrayOf(
                  PropTypes.shape({
                    expiration_date: PropTypes.string,
                    inclusion_date: PropTypes.string,
                    informant: PropTypes.string,
                    debtor_type: PropTypes.string,
                    creditor: PropTypes.string,
                    currency: PropTypes.string,
                    value: PropTypes.number,
                    contract: PropTypes.string,
                    origin: PropTypes.string,
                    subjudice: PropTypes.string,
                    modality: PropTypes.string,
                    entity: PropTypes.string,
                  }),
                ),
              }),
              bacen_bad_check: PropTypes.shape({
                quantity_ocurrence: PropTypes.string,
                account_holder: PropTypes.string,
                person_type: PropTypes.string,
                cpfcnpj: PropTypes.string,
                ocurrences: PropTypes.array,
              }),
              cadin: PropTypes.shape({
                quantity_ocurrence: PropTypes.string,
                ocurrences: PropTypes.array,
              }),
            }),
            vehicle: PropTypes.object,
            msg_infos: PropTypes.array,
            msg_errors: PropTypes.array,
          }),
        }),
      }),
    }),
  }).isRequired,
}

export default BuildFinancialPendingsInfo
